import "./style.scss";
import React, { useState } from "react";
import { Menu, MenuItem, Avatar, Button } from "@mui/material";
import Settings from "../../Assests/icons/settings.svg";
import Signout from "../../Assests/icons/sign_out.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";


function ProfileCard() {
  const navigate = useNavigate();
  const distributorDetails = useSelector(
    (state) => state.profileSettings?.getDistributorDetailReq?.response || []
  );
  const name = `${distributorDetails[0]?.firstName ?? ""} ${distributorDetails[0]?.lastName ?? ""}`
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    const target = e.target.id;
    if(target === "settings"){
      navigate("/profile-details");
    } else if(target === "sign_out"){
      Cookies.remove("authToken");
      Cookies.remove("loginStatus");
      navigate("/signin");
    }
    setAnchorEl(null);
  };

  // Generate initials from the name
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  if(!distributorDetails){
    return <></>;
  }
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Button
        onClick={handleClick}
        style={{ textTransform: "none", display: "flex", alignItems: "center" }}
      >
        <Avatar style={{ backgroundColor: "#000", marginRight: "10px" }}>
          {getInitials(name)}
        </Avatar>
        <div>
          <h3 className="user-name">{name}</h3>
          <p className="membership-info"></p>
        </div>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleClose} id="settings">
          <img src={Settings} alt="settings" className="menu-icon"/>
          Profile Settings
        </MenuItem>
        <MenuItem onClick={handleClose} id="sign_out">
          <img src={Signout} alt="sign_out" className="menu-icon"/>
          Sign Out
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileCard;
